import clsx from 'clsx';
import { useViewport } from 'hooks/3catinfo/useViewport';
import Imatge from 'components/3catinfo/Imatge';
import CercaMunicipi from 'components/3catinfo/CercaMunicipi';
import styles from './cercadorMunicipi.module.scss';
import stylesCerca from './cercaMunicipi.module.scss';

const CercadorMunicipi = (props) => {
    const {
        titol = 'Com es veurà l’eclipsi al teu municipi',
        subtitol = 'Consulta l’hora, la durada i el % de visibilitat',
        label = 'Cerca',
        imgFons,
        municipis
    } = props;

    const { zoomNavigator, isMobile } = useViewport();

    const getImatge = () => {
        const imatge = !isMobile && imgFons;
        return imatge ? (
            <div className={styles.wrapperImg}>
                <Imatge src={imatge} layout='fill' className={styles.bg} mostrarRecursTitol={false} objectFit='cover' alt='' />
            </div>
        ) : (
            <></>
        );
    };

    const stylesWrrapper = clsx({
        [styles.wrapper]: true,
        [styles.ambZoom]: zoomNavigator > 2.5,
        [styles.ambZoom400]: zoomNavigator > 3
    });

    return (
        <div className={stylesWrrapper}>
            <div className={styles.contentInfo}>
                <div className={styles.innerWrapper}>
                    <div className={styles.content}>
                        <div className={styles.header}>
                            <h2>{titol}</h2>
                            <p className={styles.subtitol}>{subtitol}</p>
                        </div>
                        <div className={styles.contentCaixaCerca}>
                            <CercaMunicipi
                                placeholder={label}
                                styles={stylesCerca}
                                routePath='web_3catinfo_eclipsi_municipi'
                                getTitle={(item) => `Eclipsi a ${item.nom}`}
                                municipisList={municipis?.municipis}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {getImatge()}
        </div>
    );
};

export default CercadorMunicipi;
